// Module
var code = "<div class=\"px-8 mx-auto max-w-screen-xl\"> <div view=\"CardList\" data=\"[[ this.data ]]\"></div> </div> ";
// Exports
export default code;